// Ссылки на точку в 2ГИС. Веб: ?m=lon,lat/zoom центрирует карту на точке
// (проверено: 2gis.kz сохраняет параметр при редиректе). Мобильное приложение
// веб-ссылку часто открывает «просто 2ГИС» без точки, поэтому для телефона
// есть ещё схема приложения dgis://.../geo/lon,lat.
export const twoGisWebUrl = (lat: number, lon: number): string => `https://2gis.kz/almaty?m=${lon}%2C${lat}%2F17`;
export const twoGisAppUrl = (lat: number, lon: number): string => `dgis://2gis.ru/geo/${lon},${lat}`;
export const isMobileUserAgent = (ua: string): boolean => /Android|iPhone|iPad|iPod/i.test(ua);

// На телефоне сначала пробуем приложение; если оно не открылось (страница
// осталась на экране), через паузу открываем веб-версию.
export const openInTwoGis = (lat: number, lon: number, ua: string = navigator.userAgent): void => {
  const web = twoGisWebUrl(lat, lon);
  if (!isMobileUserAgent(ua)) {
    window.open(web, "_blank", "noopener,noreferrer");
    return;
  }
  let left = false;
  const onHide = () => {
    if (document.hidden) left = true;
  };
  document.addEventListener("visibilitychange", onHide);
  window.location.href = twoGisAppUrl(lat, lon);
  window.setTimeout(() => {
    document.removeEventListener("visibilitychange", onHide);
    if (!left) window.open(web, "_blank", "noopener,noreferrer");
  }, 1200);
};

// Google Карты: универсальная ссылка api=1 открывает приложение на телефоне и
// веб-карту на компьютере, с меткой в точке.
export const googleMapsUrl = (lat: number, lon: number): string =>
  `https://www.google.com/maps/search/?api=1&query=${lat}%2C${lon}`;
